var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconLogout(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.999 24A2.001 2.001 0 010 22V2C0 .897.896 0 1.999 0H14C15.104 0 16 .897 16 2v5a1 1 0 01-1.999 0V2H2v20H14v-5A1 1 0 0116 17v5c0 1.103-.896 2-1.999 2H2zM19 17a.999.999 0 01-.707-1.707L20.587 13H7a1 1 0 010-2h13.587l-2.293-2.293a.999.999 0 111.414-1.414l4 4a.999.999 0 01.216 1.09.999.999 0 01-.216.324l-4 4a.997.997 0 01-.707.293z",
    fill: "#222",
    fillRule: "evenodd",
    className: "fi-icon-base-fill"
  })));
}

export default SvgIconLogout;